// Light / dark for apps that only need the mode. Backed by the suite
// appearance store (appearance.ts), so it follows the look chosen in any app —
// and this app's own look when it has one. Prefer useSuiteAppearance for new code.
import { useSuiteAppearance } from "./appearance";

export type Theme = "light" | "dark";

export function useSuiteTheme() {
    const { resolved, setLook } = useSuiteAppearance();
    return {
        theme: resolved as Theme,
        setTheme: (t: Theme) => setLook({ mode: t }),
        toggle: () => setLook({ mode: resolved === "light" ? "dark" : "light" })
    };
}
